export default __webpack_public_path__ + "static/media/xlsx.5b41e963.svg";